document.addEventListener("DOMContentLoaded", () => {
    if (document.querySelector('.pdw-arrow-service')) {
        document.querySelector('#services-prev').addEventListener('click', () => {
            document.querySelector('.splide__arrow--prev').click();
        });
        document.querySelector('#services-next').addEventListener('click', () => {
            document.querySelector('.splide__arrow--next').click();
        });
    }
});